import { gql } from 'apollo-angular';

const GET_VIZIENT_REVIEW_OPTIONS = gql`
  query getVizientReviewOptions {
    vizientReviewOptions {
      optionKey
      opinion
      feedback
      feedbackDescription
    }
  }
`;

export default GET_VIZIENT_REVIEW_OPTIONS;
